import mime from 'mime/lite';
import download from 'downloadjs';

export const downloadImage = (image, fileName = 'depix-image') => {
  const extension = mime.getExtension(image.file.type);
  download(image.file, `${fileName}.${extension}`);
};
